module.exports = __webpack_public_path__ + "img/c-thermometer-img3-2.5ac6948a.png";